export default __webpack_public_path__ + "static/jarratt-854fd4f9890ad18b51d6edcc3f2f48c1.jpg";